import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-settings" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = {
  key: 0,
  class: "profile"
}
const _hoisted_4 = { class: "profile__info" }
const _hoisted_5 = { class: "profile__password" }
const _hoisted_6 = { class: "profile__password--body" }
const _hoisted_7 = {
  key: 1,
  class: "users"
}
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = { class: "actions__edit" }
const _hoisted_10 = { class: "actions__delete" }
const _hoisted_11 = { style: {"display":"flex","margin-bottom":"12px"} }
const _hoisted_12 = { class: "modal__footer" }
const _hoisted_13 = { class: "modal__footer" }

import CustomTab from "@/components/custom/CustomTab.vue";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref, watch} from "vue";
import CommonButton from "@/components/common/CommonButton.vue";
import {Edit02, Eye, EyeOff, Plus, Trash01} from "utruckin-icons"
import CommonTable from "@/components/common/CommonTable.vue";
import {ITableHeader} from "@/types/table";
import CommonInput from "@/components/common/CommonInput.vue";
import {useAuthStore} from "@/features/auth/auth.store";
import {IProfile} from "@/features/auth/auth.types";
import {IAdminUser} from "@/features/admin/admin.types";
import {useAdminStore} from "@/features/admin/admin.store";
import CustomBadge from "@/components/custom/CustomBadge.vue";
import {useAlert} from "@/utils/alert";
import CommonModal from "@/components/common/CommonModal.vue";
import {useAppStore} from "@/store/app.store";

interface IUserModal {
  role: 'viewer' | 'admin';
  email: string;
  password: string;
  confirmPassword: string;
  id: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const adminStore = useAdminStore();
const {show} = useAlert()
const appStore = useAppStore();

const activeTab = ref<number>(1);
const typeNewPasswordInput = ref<"password" | "text">("password");
const typeConfirmPasswordInput = ref<"password" | "text">("password");
const profileLoading = ref<boolean>(false);
const usersLoading = ref<boolean>(false);

const usersList = ref<IAdminUser[]>([]);

const role = ref<string>("");
const email = ref<string>("");
const user = ref<IProfile | null>(null);
const password = ref<string>("");
const confirmPassword = ref<string>("");

const editingModal = ref<boolean>(false);
const modalTitle = ref<string>("");
const modalItem = ref<IUserModal>({
  role: "viewer",
  email: "",
  password: "",
  confirmPassword: "",
  id: 0
})
const modalPasswordType = ref<'password' | 'text'>("password");
const modalConfirmPasswordType = ref<'password' | 'text'>("password");

const deletingModal = ref<boolean>(false);
const deleteModalItem = ref<any>()

const tabs = [
  {label: "Profile", value: 1},
  {label: "Users", value: 2},
]

const roleTabs = [
  {label: "Viewer", value: 'viewer',},
  {label: "Admin", value: 'admin',}
]

const headers: ITableHeader[] = [
  {
    name: 'id',
    label: 'No',
    fitContent: true
  },
  {
    name: 'email',
    label: 'Email',
    width: '300px'
  },
  {
    name: 'role',
    label: 'Role',
    width: '300px'
  },
  {
    name: 'is_active',
    label: 'Status',
    width: '300px'
  },
  {
    name: 'actions',
    label: 'Actions',
    fitContent: true
  }
]

const handleAppendClickNewPassword = () => {
  if (typeNewPasswordInput.value === "password") {
    typeNewPasswordInput.value = "text"

  } else {
    typeNewPasswordInput.value = "password"
  }
}

const handleAppendClickConfirmPassword = () => {
  if (typeConfirmPasswordInput.value === "password") {
    typeConfirmPasswordInput.value = "text"

  } else {
    typeConfirmPasswordInput.value = "password"
  }
}

const getProfile = async () => {
  user.value = await authStore.getProfile(profileLoading);
}

const updateProfile = async () => {
  let payload: IAdminUser = {
    email: user.value?.email as string,
    role: user.value?.role as 'admin' | 'viewer',
    password: password.value,
    is_active: user.value?.is_active as boolean
  }
  let response = await adminStore.updateUser(profileLoading, payload, user.value?.id as number)

  if (response.status == 'updated') {
    show("Saved successfully", "success");
    password.value = "";
    confirmPassword.value = "";
  }
}

const getUsers = async () => {
  usersList.value = await adminStore.getUsers(usersLoading);
}

const closeModal = () => {
  modalTitle.value = "";
  modalItem.value = {
    role: "viewer",
    email: "",
    password: "",
    confirmPassword: "",
    id: 0
  }
}

const editAdminUser = (e: any, user?: IAdminUser) => {
  if (user) {
    modalTitle.value = "Edit user";
    modalItem.value = {
      role: user.role,
      email: user.email,
      password: "",
      confirmPassword: "",
      id: user.id as number
    }
  } else {
    modalTitle.value = "Add user";
    modalItem.value = {
      role: "viewer",
      email: "",
      password: "",
      confirmPassword: "",
      id: 0
    }
  }

  editingModal.value = true;
}

const cancelModalButton = () => {
  editingModal.value = false;
  closeModal()
}

const saveModalButton = async () => {
  if (
      !modalItem.value.email &&
      !modalItem.value.password &&
      modalItem.value.password !== modalItem.value.confirmPassword
  ) {
    return;
  }
  let result;
  let request = {
    email: modalItem.value.email,
    password: modalItem.value.password,
    role: modalItem.value.role,
    is_active: true
  }
  if (modalTitle.value === "Add user") {
    result = await adminStore.createUser(usersLoading, request)
  } else {
    result = await adminStore.updateUser(usersLoading, request, modalItem.value.id)
  }

  if (result) {
    show("Saved successfully", "success");
    cancelModalButton()
    appStore.triggerRefresh()
  }
}

const openDeleteModal = (item: IAdminUser) => {
  deletingModal.value = true;
  deleteModalItem.value = item;
}

const closeDeleteModal = () => {
  deleteModalItem.value = undefined;
}

const cancelDeleteButton = () => {
  deletingModal.value = false;
}

const deleteUser = async () => {
  let response = await adminStore.deleteUser(usersLoading, deleteModalItem.value.id);

  if (response.status === "deactivated") {
    show("Deactivated successfully", "success");
    cancelDeleteButton()
    appStore.triggerRefresh()
  }
}

onMounted(() => {
  if (route.query.name === "users") {
    activeTab.value = 2;
    getUsers()
  } else {
    activeTab.value = 1;
    getProfile()
  }
})

watch(
    () => activeTab.value,
    (newVal, oldVal) => {
      if (newVal !== oldVal) {
        if (newVal == 1) {
          router.push({
            path: "/settings",
            query: {
              name: 'profile'
            }
          })
        } else {
          router.push({
            path: "/settings",
            query: {
              name: 'users'
            }
          })
        }
      }
    }
)

watch(
    () => route.query.name,
    (newVal) => {
      if (newVal === 'users') {
        activeTab.value = 2;
        getUsers()
      } else {
        activeTab.value = 1;
        getProfile()
      }
    }
)

watch(
    () => appStore.refreshKey,
    () => {
      if (route.query.name === "users") {
        getUsers()
      } else {
        getProfile()
      }
    },
    {
      immediate: false,
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["header", activeTab.value == 1 ? 'border' : ''])
      }, [
        _createVNode(CustomTab, {
          tabs: tabs,
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event))
        }, null, 8, ["modelValue"]),
        (activeTab.value == 2)
          ? (_openBlock(), _createBlock(CommonButton, {
              key: 0,
              prepend: "",
              "prepend-icon": _unref(Plus),
              type: "primary",
              label: "Add user",
              onClick: editAdminUser
            }, null, 8, ["prepend-icon"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        (activeTab.value == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "profile__info--header" }, " Profile info ", -1)),
                (user.value)
                  ? (_openBlock(), _createBlock(CommonInput, {
                      key: 0,
                      label: "Role",
                      placeholder: "Role",
                      "model-value": user.value.role,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.role) = $event)),
                      disabled: ""
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true),
                (user.value)
                  ? (_openBlock(), _createBlock(CommonInput, {
                      key: 1,
                      label: "Email",
                      placeholder: "Email",
                      "model-value": user.value.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.email) = $event)),
                      disabled: ""
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "profile__password--header" }, " New password ", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(CommonInput, {
                    type: typeNewPasswordInput.value,
                    "model-value": password.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
                    label: "New password",
                    placeholder: "New password",
                    "append-icon": typeNewPasswordInput.value == 'password' ? _unref(Eye) : _unref(EyeOff),
                    onAppendIconClick: handleAppendClickNewPassword,
                    error: password.value.length < 6,
                    errorMessage: "Password should have at least 6 characters"
                  }, null, 8, ["type", "model-value", "append-icon", "error"]),
                  _createVNode(CommonInput, {
                    type: typeConfirmPasswordInput.value,
                    "model-value": confirmPassword.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPassword).value = $event)),
                    label: "Confirm password",
                    placeholder: "Confirm password",
                    "append-icon": typeConfirmPasswordInput.value == 'password' ? _unref(Eye) : _unref(EyeOff),
                    onAppendIconClick: handleAppendClickConfirmPassword,
                    error: password.value !== confirmPassword.value,
                    errorMessage: "Passwords must be the same"
                  }, null, 8, ["type", "model-value", "append-icon", "error"]),
                  _createVNode(CommonButton, {
                    type: "primary",
                    label: "Save password",
                    "is-disabled": password.value !== confirmPassword.value || (!password.value) || password.value.length < 6,
                    onClick: updateProfile
                  }, null, 8, ["is-disabled"])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(CommonTable, {
                loading: usersLoading.value,
                headers: headers,
                items: usersList.value
              }, {
                id: _withCtx(({index}) => [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ]),
                is_active: _withCtx(({item}) => [
                  _createVNode(CustomBadge, {
                    title: item['is_active'] ? 'Active' : 'Inactive',
                    type: item['is_active'] ? 'success' : 'danger'
                  }, null, 8, ["title", "type"])
                ]),
                actions: _withCtx(({item}) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(Edit02), {
                        size: 16,
                        onClick: (e) => editAdminUser(e, item as IAdminUser)
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(Trash01), {
                        size: 16,
                        onClick: ($event: any) => (openDeleteModal(item))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading", "items"])
            ]))
      ])
    ]),
    _createVNode(CommonModal, {
      modelValue: editingModal.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editingModal).value = $event)),
      title: modalTitle.value,
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(CommonButton, {
            type: "secondary",
            label: "Cancel",
            onClicked: cancelModalButton
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModalButton
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(CustomTab, {
              tabs: roleTabs,
              modelValue: modalItem.value.role,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalItem.value.role) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(CommonInput, {
            label: "Email",
            placeholder: "Email",
            "model-value": modalItem.value.email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((modalItem.value.email) = $event)),
            error: !modalItem.value.email,
            errorMessage: "Value is required"
          }, null, 8, ["model-value", "error"]),
          _createVNode(CommonInput, {
            type: modalPasswordType.value,
            "model-value": modalItem.value.password,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modalItem.value.password) = $event)),
            label: "New password",
            placeholder: "New password",
            "append-icon": modalPasswordType.value == 'password' ? _unref(Eye) : _unref(EyeOff),
            onAppendIconClick: _cache[8] || (_cache[8] = () => {
            modalPasswordType.value = modalPasswordType.value == 'password' ? 'text' : 'password'
          }),
            error: modalItem.value.password.length < 6,
            errorMessage: "Password should have at least 6 characters"
          }, null, 8, ["type", "model-value", "append-icon", "error"]),
          _createVNode(CommonInput, {
            type: modalConfirmPasswordType.value,
            "model-value": modalItem.value.confirmPassword,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((modalItem.value.confirmPassword) = $event)),
            label: "Confirm password",
            placeholder: "Confirm password",
            "append-icon": modalConfirmPasswordType.value == 'password' ? _unref(Eye) : _unref(EyeOff),
            onAppendIconClick: _cache[10] || (_cache[10] = () => {
            modalConfirmPasswordType.value = modalConfirmPasswordType.value == 'password' ? 'text' : 'password'
          }),
            error: modalItem.value.password !== modalItem.value.confirmPassword,
            errorMessage: "Passwords must be the same"
          }, null, 8, ["type", "model-value", "append-icon", "error"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(CommonModal, {
      modelValue: deletingModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((deletingModal).value = $event)),
      onClose: closeDeleteModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(CommonButton, {
            type: "secondary",
            label: "Cancel",
            onClicked: cancelDeleteButton
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: deleteUser
          })
        ])
      ]),
      default: _withCtx(() => [
        _cache[15] || (_cache[15] = _createElementVNode("div", null, " Are you sure you want to deactivate this user? This action cannot be undone. ", -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})